import { availableLocales } from "@/config/availableLocales";
import { defineConfig } from "@/features/featureFlag/defineConfig";

const languageOptions = [
  ...availableLocales.map((locale) => ({
    value: locale.code,
    label: locale.displayName,
  })),
  /**
   * HINT: For easy testing - setting lng to 'cimode' will set t function to always return the key.
   */
  {
    label: "Keys",
    value: "cimode",
  },
];

export const featureFlagConfigs = defineConfig({
  alwaysHideDevModeHint: {
    type: "toggle",
    label: "Always hide DevMode hint",
  },
  quickI18n: {
    label: "Quick switch language",
    type: "singleSelect",
    options: languageOptions,
  },
  "tanstack-router-devtool": {
    label: "Enable tanstack router devtool",
    type: "singleSelect",
    options: [
      {
        value: "bottom-right",
        label: "Bottom right",
      },
      {
        value: "top-left",
        label: "Top left",
      },
      {
        value: "top-right",
        label: "Top right",
      },
      {
        value: "bottom-left",
        label: "Bottom left",
      },
    ],
  },
  "react-query-devtool": {
    label: "Enable react-query devtool",
    type: "singleSelect",
    options: [
      {
        value: "bottom",
        label: "Bottom",
      },
      {
        value: "top",
        label: "Top",
      },
      {
        value: "right",
        label: "Right",
      },
      {
        value: "left",
        label: "Left",
      },
    ],
  },
  "enable-whatsapp-compliance": {
    label: "Enable WhatsApp compliance",
    type: "toggle",
  },
  "enable-whatsapp-conversational-components": {
    label: "Enable WhatsApp conversational components",
    type: "toggle",
  },
  "enable-vibe-lab": {
    label: "Enable Vibe Lab",
    type: "toggle",
  },
  "enable-event-status-checker": {
    label: "Enable Event Status Checker",
    type: "toggle",
  },
  "enable-openapi-v2-key-self-serve": {
    label: "Enable OpenAPI v2 API key self-serve",
    type: "toggle",
  },
  "enable-openapi-v2-ip-allowlist": {
    label: "Enable OpenAPI v2 IP allowlist",
    type: "toggle",
  },
  "enable-mcp-connections": {
    label: "Enable MCP connections",
    type: "toggle",
  },
  /**
   * A local override for the `enable_custom_field_single_select` Statsig gate,
   * so the single select creation flow can be exercised without console
   * access to that gate. It exists because the gate is per-organization and
   * the release plan opens it late; without a local switch there is no way to
   * see the flow at all before then.
   *
   * TODO(#819): remove this once the gate is open for the accounts that need
   * it, or sooner if the Statsig gate override lands first -- that layer makes
   * a per-gate toggle like this one unnecessary.
   */
  "enable-custom-field-single-select": {
    label: "Enable custom field single select",
    type: "toggle",
  },
  /**
   * A local override for the `enable_line_channel_creation` Statsig gate, so
   * the LINE creation flow can be exercised before the gate exists in Statsig.
   */
  "enable-line-channel-creation": {
    label: "Enable LINE channel creation",
    type: "toggle",
  },
});
